import axios from 'axios'
import config from '../config/dev.json'
import Vue from 'vue'
let urlSecure = config.host + path +'/secure'
import { refresh } from './auth.service.js'

let path = '/api/v1'
let url = config.host + path + '/secure/support'

import production from '../config/production.json'

if( process.env.NODE_ENV === 'production'){
  url = production.host + path +'/secure/support'
}

export async function getTicketById(id){
  return new Promise((resolve, reject) => {
    axios.get(url +'/get/'+id).then((response) => {
      let ticket = response.data.data
      resolve(ticket)
    }).catch(err => {
      if(err.response.status === 401){
        refresh().then(() => {
          resolve(getTicketById(id))
        }).catch(err => reject(err))
      }
    })
  })
}
export async function getAllTicket() {
  return new Promise((resolve, reject) => {
    axios.get(url+ '/get/all').then((response) => {
      let tickets = response.data.data
      resolve(tickets)
    }).catch(err => {
      if(err.response.status === 401){
        refresh().then(() => {
          resolve(getAllTicket())
        }).catch(err => reject(err))
      }
    })
  })
}
export async function getAllTicketByUser() {
  console.log("api service fet all tickets by user")
  return new Promise((resolve, reject) => {
    axios.get(url+ '/get/user/all').then((response) => {
      let tickets = response.data.data
      resolve(tickets)
    }).catch(err => {
      if(err.response.status === 401){
        refresh().then(() => {
          resolve(getAllTicketByUser())
        }).catch(err => reject(err))
      }
    })
  })
}




export async function addTickets(ticket) {
  return new Promise((resolve, reject) => {
    console.log("****** service ********", ticket)
    axios.post(url + '/add', ticket).then((response) => {
      let ticket = response.data.data
      resolve(ticket)
    }).catch(err => reject(err))
  })
}

export async function updateTicket(ticket){
  return new Promise((resolve, reject) => {
    console.log("################## servive ticket._id####### ",ticket._id)
    console.log("################## servive ticket####### ",ticket)

    axios.put(url + '/update/' + ticket._id, ticket).then((response) => {
      let upIntent = response.data.data
      resolve(upIntent)
    }).catch(err => reject(err))
  })
}







// WEBPACK FOOTER //
// ./src/api/support.service.js